import React, { useEffect, useState } from 'react';
import * as R from 'ramda';
import { useHistory } from 'react-router-dom';
import ReactGA from 'react-ga';

import { GatewayStatus, useGateway } from '@civic/solana-gateway-react';
import StatusViewContainer from './StatusViewContainer';
import StatusPanelContent from './StatusPanelContent';

export default function TokenStatusPanel(): JSX.Element {
  const history = useHistory();

  const { gatewayStatus, requestGatewayToken } = useGateway();
  const [isStatusLoading, setIsStatusLoading] = useState<boolean>(true);
  const [status, setStatus] = useState<string>(GatewayStatus[GatewayStatus.CHECKING]);
  const googleAnalyticsEvent = `Token ${status} - Civic Pass`;

  useEffect(() => {
    const isLoading = R.isEmpty(gatewayStatus) || gatewayStatus === GatewayStatus.CHECKING;
    setIsStatusLoading(isLoading);
    setStatus(GatewayStatus[gatewayStatus]);
  }, [gatewayStatus]);

  const handleButtonClick = () => {
    requestGatewayToken();
  };

  const handleLearnMore = () => {
    history.push('/documentation');
  };

  useEffect(() => {
    ReactGA.pageview(window.location.pathname, [], googleAnalyticsEvent);
  }, [googleAnalyticsEvent]);

  return (
    <StatusViewContainer
      iframeContainerCssClass="status-panel flex items-center justify-center"
      mainContainerCssClass="status-container"
    >
      <>
        {isStatusLoading && <div className="loading-spinner" />}
        {!isStatusLoading && (
          <StatusPanelContent status={status} handleButtonClick={handleButtonClick} handleLearnMore={handleLearnMore} />
        )}
      </>
    </StatusViewContainer>
  );
}

TokenStatusPanel.defaultProps = {};
